(ns yardwerkz.web.profile.edit-profile
  "Edit profile: name, avatar."
  (:require
   [uix.core :refer [defui $ use-state]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.router :as router]
   [yardwerkz.web.ui.layout :as layout]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

(defui edit-profile-page []
  (let [identity (rfx/use-sub [::store/identity])
        dispatch (rfx/use-dispatch)
        [first-name set-first] (use-state (or (:first-name identity) ""))
        [last-name set-last] (use-state (or (:last-name identity) ""))
        [saving set-saving] (use-state false)]
    ($ layout/page-container
       ($ :button {:class "flex items-center text-sm text-gray-500 hover:text-gray-700 mb-4"
                   :on-click #(router/navigate! :profile)}
          ($ icons/ChevronLeft {:size 16})
          ($ :span "Back to Profile"))
       ($ :h1 {:class "text-2xl font-bold text-gray-900 mb-6"} "Edit Profile")
       ($ :div {:class "space-y-4 max-w-md"}
          ($ ui/input {:label "First Name" :value first-name :on-change set-first})
          ($ ui/input {:label "Last Name" :value last-name :on-change set-last})
          ($ ui/button {:loading saving
                        :on-click (fn []
                                    (set-saving true)
                                    (dispatch [::store/update-profile
                                               {:data {:first-name first-name :last-name last-name}
                                                :on-success (fn [_]
                                                              (set-saving false)
                                                              (ui/show-toast! :success "Profile updated"))
                                                :on-failure (fn [_]
                                                              (set-saving false)
                                                              (ui/show-toast! :error "Update failed"))}]))}
             "Save Changes")))))
